import { render } from "./PostItem.vue?vue&type=template&id=410d7c84&scoped=true"
import script from "./PostItem.vue?vue&type=script&lang=js"
export * from "./PostItem.vue?vue&type=script&lang=js"

import "./PostItem.vue?vue&type=style&index=0&id=410d7c84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-410d7c84"

export default script